import React, { Component } from 'react';
import { Spin, Row, Button } from 'antd';
import { app, api, config } from "../../../app";
import { Link } from 'react-router-dom';

class TeamMienDetail extends Component {
    constructor (props) {
        super(props);
        this.state = {
            dataList: [],
            data_loading: true,
            id: props.match.params.id,
            style_title: "正在加载 ... ",
            teamname: "正在加载 ... "
        };
    }

    async componentDidMount () {
        this._isMounted = true;
        await this.handleData();
    }

    componentWillUnmount () {
        this._isMounted = false;
    }

    setData = (data) => app.setStateSync(this, data);

    /**
     * 数据处理
     * @returns {Promise<void>}
     */
    handleData = async () => {
        let { id } = this.state,
            params = {
                id,
                request: "team",
            }, { flag, data, msg } = await app.post(api.TeamStyleImg, params);
        let state = { data_loading: false };
        if (flag === 1) {
            state.dataList = data.style_img;
            state.teamname = data.teamname;
            state.style_title = data.style_title;
        } else {
            app.alert(msg, "error");
        }
        this.setData(state);
    };

    render () {
        let { data_loading, dataList, teamname, style_title } = this.state;
        return (
            <div className="mien-page">
                <Row className="mien-title" type="flex" justify="space-between">
                    <span>队伍风采详情（{teamname}）</span>
                    <Button type="primary" onClick={() => this.props.history.go(-1)}>返回</Button>
                </Row>
                <div className="mp-content">
                    <h2 className="dl-title">{style_title}</h2>
                    <Row className="no-data" type="flex" justify="center" align="middle" hidden={!data_loading}><Spin/></Row>
                    <div className="dl-imgs" style={{ padding: 10 }} hidden={data_loading}>
                        {
                            dataList.map((img, i) => {
                                return (
                                    <div className="dl-img" key={i}>
                                        <a href={config.imgUrl + img} target="_blank"><img src={config.imgUrl + img}/></a>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default TeamMienDetail;



// WEBPACK FOOTER //
// ./src/routes/ranks/TeamMore/TeamMienDetail.jsx